import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
      <h1 className="text-9xl font-bold text-primary opacity-20">404</h1>
      <h2 className="text-3xl font-bold text-gray-800 mt-4 mb-2">Page introuvable</h2>
      <p className="text-gray-500 mb-8 text-center">
        La page que vous cherchez n'existe pas ou a été déplacée.
      </p>
      <Link
        to="/"
        className="bg-primary text-white px-8 py-3 rounded-xl font-semibold hover:bg-blue-800 transition flex items-center gap-2"
      >
        <FiArrowLeft size={18} />
        Retour à l'accueil
      </Link>
    </div>
  );
};

export default NotFound;